
export default {
	name: "RadioButton",
	props: {
		label: {
			type: String,
			required: true,
		},
		value: {
			type: [String, Number],
			default: null,
		},
		name: {
			type: String,
			required: true,
		},
		checked: {
			type: Boolean,
		},
	},
};
